/** @format */

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import styles from "./CreateOrder.module.scss";
import commonStyle from "../common.module.scss";
import { numberToFinanceFormat } from "../../../../utils";
import InfoIcon from "../../../shared/icons/InfoIcon";
import CargoInsurance from "../../cargo-insurance/CargoInsurance";
import ToggleSwitchIcon from "../../../shared/icons/ToggleSwitchIcon";
import OrderCustomInput from "../../../CreateOrder/Input/OrderCustomInput";
import CustomInputCurrency from "../../../custom/custom-input-currency/CustomInputCurrency";
import { CURRENCIES } from "../../../../mock";
import AccessDeniedModal from "../../../shared/SubscriptionModal/AccessDeniedModal";

const OrdersSectionItemPaymentExpeditor = ({
  title,
  withInsurance = false,
  priceDiscount = 0,
  price = 0,
  changeInput,
  defaultCount,
  onPriceChange,
  algoPrice,
  predictedPrice = {},
  errorText = "",
  queryInsurance,
  declaredPrice,
  calcInsurance,
  fileInvoice,
  setInvoiceFile,
  errorInsurance = "",
  errorFileInvoice = "",
  saveDraft,
  user,
  errorExecutor,
  companyName,
  currency,
  setCurrency,
  isOwnFleetExecutor,
  setIsOwnFleetExecutor,
  isReadOnly = false,
}) => {
  const { t } = useTranslation();
  const [count, setCount] = useState(defaultCount);
  const [isDisplayModal, changeDisplayModal] = useState(false);

  const incrementCount = () => {
    if (count < 15) {
      setCount(count + 1);
    }
  };

  const decrementCount = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  useEffect(() => {
    if (count !== defaultCount && changeInput) {
      changeInput(count);
    }
  }, [count]);

  const handleToggleAutopack = () => {
    if (isReadOnly) return;

    if (user && user.permissions?.includes("restricted_view")) {
      changeDisplayModal(true);
      return;
    }

    setIsOwnFleetExecutor(!isOwnFleetExecutor);
  };

  const totalPrice = () => {
    return Number(price) + Number(priceDiscount);
  };

  return (
    <>
      <div className={commonStyle.createOrderContainer}>
        {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}

        <div className={commonStyle.createOrderContainer_price}>
          <div className={commonStyle.algo}>
            <InfoIcon width="20px" height="20px" />

            {!(user && user.permissions?.includes("algo_availability")) ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className={commonStyle.typography_large}>{title}</span>
                <span className={commonStyle.typography_regular} style={{ color: "#FF8502" }}>
                  {t("ordersCreateDesktop.paymentSection.unavailableInCurrentTariff")}
                </span>
              </div>
            ) : algoPrice ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className={commonStyle.typography_large}>
                  {numberToFinanceFormat(Math.round(algoPrice))} ₸
                </span>
                <span className={commonStyle.typography_regular}>{title}</span>
              </div>
            ) : Object.keys(predictedPrice).length > 0 ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className={commonStyle.typography_regular}>{title}</span>
                <span className={commonStyle.typography_large}>
                  {numberToFinanceFormat(Math.round(predictedPrice?.urgent_1_3_days))} ₸ (1-3 дня)
                </span>
                <span className={commonStyle.typography_large}>
                  {numberToFinanceFormat(Math.round(predictedPrice?.medium_3_7_days))} ₸ (3-7 дней)
                </span>
                <span className={commonStyle.typography_large}>
                  {numberToFinanceFormat(Math.round(predictedPrice?.standard_7_plus_days))} ₸ (7+ дней)
                </span>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span className={commonStyle.typography_large}>
                  {t("ordersCreateDesktop.paymentSection.priceUndefined")}
                </span>
                <span className={commonStyle.typography_regular} style={{ color: "#FF8502" }}>
                  {t("ordersCreateDesktop.paymentSection.fillAllFieldsToCalc")}
                </span>
              </div>
            )}
          </div>
          <div style={{ flex: "1" }}>
            <CustomInputCurrency
              labelText={t("ordersCreateDesktop.paymentSection.cargoTransportationPrice")}
              placeholder={t("ordersCreateDesktop.paymentSection.addYourSum")}
              errorText={errorText}
              isBgGray={true}
              inputType="number"
              value={price}
              currency={currency}
              onChangeValue={(item) => {
                onPriceChange(item);
              }}
              onChangeCurrency={(currencyCode) => {
                setCurrency(currencyCode);
              }}
            />
          </div>
        </div>

        <div className={cn(commonStyle.checkbox_wrapper)}>
          <div className={commonStyle.checkbox_content}>
            <p>{t("ordersCreateDesktop.paymentSection.orderDuplicate")}</p>
            <span>{t("ordersCreateDesktop.paymentSection.orderDuplicateQuantity")}</span>
          </div>
          <div className={styles["createOrder__amount-count"]}>
            <button className={styles["createOrder__amount-button"]} onClick={decrementCount}>
              -
            </button>
            <OrderCustomInput value={count} onChange={(e) => setCount(parseInt(e.target.value) || 0)} />
            <button className={styles["createOrder__amount-button"]} onClick={incrementCount}>
              +
            </button>
          </div>
        </div>

        <CargoInsurance
          isReadOnly={isReadOnly}
          defaultValue={withInsurance}
          onClick={queryInsurance}
          declaredPrice={declaredPrice}
          errorInsurance={errorInsurance}
          errorFileInvoice={errorFileInvoice}
          setDeclaredPrice={calcInsurance}
          fileInvoice={fileInvoice}
          setInvoiceFile={setInvoiceFile}
          detect={saveDraft}
        />

        <div
          className={cn(commonStyle.checkbox_wrapper, {
            [commonStyle.checkbox_errorState]: errorExecutor,
          })}
        >
          <div className={commonStyle.checkbox_content}>
            <p>
              {t("orderInfo.ordersDriverInfo.executorTitle")} {companyName}
            </p>
            <span>{t("ordersCreateDesktop.paymentSection.companyExecutor")}</span>
          </div>
          <div className={cn(commonStyle.checkbox_switch)} onClick={handleToggleAutopack}>
            {isOwnFleetExecutor ? <ToggleSwitchIcon type={1} /> : <ToggleSwitchIcon type={0} />}
          </div>
        </div>

        {errorExecutor && <span style={{ color: "#C84620" }}>{errorExecutor}</span>}

        <div className={commonStyle.all_price}>
          <div className={commonStyle.cargo}>
            <span className={commonStyle.typography_small}>
              {t("ordersCreateDesktop.paymentSection.transportationPrice")}
            </span>
            <div className={cn(commonStyle.cargo_price, commonStyle.typography_small)}>
              {price} {CURRENCIES[currency || "KZT"]?.symbol || ""}
            </div>
          </div>
          {/* <div className={commonStyle.cargo}>
            <span className={commonStyle.typography_small}>{t('ordersCreateDesktop.paymentSection.cargoInsurancePrice')}</span>
            <div className={cn(commonStyle.cargo_price, commonStyle.typography_small)}>
              {priceDiscount} {CURRENCIES[currency || "KZT"]?.symbol || ""}
            </div>
          </div> */}
          <div className={commonStyle.cargo}>
            <span className={commonStyle.typography_medium}>
              {t("ordersCreateDesktop.paymentSection.totalPrice")}
            </span>
            <div className={cn(commonStyle.cargo_price, commonStyle.typography_medium)}>
              {totalPrice()} {CURRENCIES[currency || "KZT"]?.symbol || ""}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrdersSectionItemPaymentExpeditor;
